import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { REPORT_PRESET } from 'modules/campaigns/modules/campaigns-reports/config/pickers';
import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import { PERFORMANCE_RULES_REPORT_ID } from './performanceRulesReportId';

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.PERFORMANCE_RULE_NAME.field,
        FIELDS.ACCOUNT_NAME.field,
        FIELDS.PERFORMANCE_RULE_TYPE.field,
        FIELDS.PERFORMANCE_RULE_DESCRIPTION.field,
        FIELDS.NUMBER_OF_EXECUTED_ACTIONS.field,
        FIELDS.LAST_MODIFIED_BY_PERFORMER.field,
        FIELDS.PERFORMANCE_RULES_LAST_MODIFY_TIME.field,
        FIELDS.APPLIES_TO_CAMPAIGNS.field,
    ].map(field => generateColumnId(PERFORMANCE_RULES_REPORT_ID, field)),
};

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.IS_ACTIVE.field,
    FIELDS.PERFORMANCE_RULE_NAME.field,
    FIELDS.ACCOUNT_NAME.field,
    FIELDS.PERFORMANCE_RULE_TYPE.field,
    FIELDS.PERFORMANCE_RULE_DESCRIPTION.field,
    FIELDS.NUMBER_OF_EXECUTED_ACTIONS.field,
    FIELDS.LAST_MODIFIED_BY_PERFORMER.field,
    FIELDS.PERFORMANCE_RULES_LAST_MODIFY_TIME.field,
    FIELDS.APPLIES_TO_CAMPAIGNS.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(PERFORMANCE_RULES_REPORT_ID, field));

export { customColumns, defaultColumns };
